import * as go from 'gojs';

const $ = go.GraphObject.make;

type CanvasModalLockState = {
  depth: number;
  previousAllowSelect: boolean;
};

type CanvasModalBlockerOptions = {
  onBlockedInput?: (event: go.InputEvent) => void;
  zOrder?: number;
};

const canvasModalLocks = new WeakMap<go.Diagram, CanvasModalLockState>();

const releaseCanvasModalLock = (diagram: go.Diagram) => {
  const state = canvasModalLocks.get(diagram);

  if (!state) {
    return;
  }

  if (state.depth > 1) {
    state.depth -= 1;
    return;
  }

  diagram.allowSelect = state.previousAllowSelect;
  canvasModalLocks.delete(diagram);
};

export const lockCanvasForModal = (diagram: go.Diagram) => {
  const state = canvasModalLocks.get(diagram);

  if (state) {
    state.depth += 1;
  } else {
    canvasModalLocks.set(diagram, {
      depth: 1,
      previousAllowSelect: diagram.allowSelect,
    });
    diagram.allowSelect = false;
  }

  let released = false;

  return () => {
    if (released) {
      return;
    }

    released = true;
    releaseCanvasModalLock(diagram);
  };
};

export const isCanvasModalOpen = (diagram: go.Diagram) =>
  canvasModalLocks.has(diagram);

export const createCanvasModalBlocker = (
  diagram: go.Diagram,
  { onBlockedInput, zOrder = 0 }: CanvasModalBlockerOptions = {},
) => {
  const viewportBounds = diagram.viewportBounds;
  const handleBlockerAction = (event: go.InputEvent) => {
    onBlockedInput?.(event);
    event.handled = true;
  };

  return $(
    go.Part,
    'Auto',
    {
      layerName: 'Tool',
      zOrder,
      selectable: false,
      pickable: true,
      isActionable: true,
      position: viewportBounds.position,
      isInDocumentBounds: false,
      actionDown: handleBlockerAction,
      actionMove: handleBlockerAction,
      actionUp: handleBlockerAction,
      click: handleBlockerAction,
      doubleClick: handleBlockerAction,
      contextClick: handleBlockerAction,
    },
    $(go.Shape, 'Rectangle', {
      width: viewportBounds.width,
      height: viewportBounds.height,
      fill: 'rgba(255, 255, 255, 0.01)',
      stroke: 'transparent',
      strokeWidth: 0,
      isActionable: true,
      actionDown: handleBlockerAction,
      actionMove: handleBlockerAction,
      actionUp: handleBlockerAction,
      click: handleBlockerAction,
      doubleClick: handleBlockerAction,
      contextClick: handleBlockerAction,
    }),
  );
};
